import { Button, Stack, styled } from '@mui/material';

export const LikeSummary = styled(Button)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  background-color: var(--dk-bg-muted, #f3f5f6);
  user-select: none;
  text-align: left;

  .profile-image-container {
    display: flex;
    flex-direction: row;
    gap: -6px;
    img {
      width: 32px;
      height: 32px;
      border-radius: 100%;
      border: 1px solid var(--dk-bg, white);
      background-color: var(--dk-bg, white);
      object-fit: cover;
      &.profile-image {
        margin-right: -12px;
      }
    }
    svg {
      width: 32px;
      height: 32px;
    }
  }

  p {
    flex: 1;
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    color: var(--dk-text, black);
    strong {
      font-weight: 700;
      color: var(--dk-accent, #0066cc);
    }
  }

  .angle-bracket-icon {
    width: 28px;
    height: 28px;
    transition-duration: 0.3s;
  }

  &.open {
    background-color: rgba(0, 102, 204, 0.08);
    .angle-bracket-icon {
      transform: rotate(-180deg);
    }
    .profile-image-container {
      .profile-image {
        display: none;
      }
    }
  }

  &:disabled {
    .angle-bracket-icon {
      path {
        stroke: var(--dk-text-disabled, #d1d8e2);
      }
    }
  }
`;

export const LikeList = styled(Stack)`
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
  background-color: var(--dk-bg-muted, #f3f5f6);
`;

export const LikeItem = styled(Button)`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 4px 12px 4px 4px;
  border: 1px solid var(--dk-line, #e7e9ec);
  background-color: var(--dk-bg, white);
  border-radius: 999px;

  img {
    width: 32px;
    height: 32px;
    border-radius: 100%;
    object-fit: cover;
  }

  span {
    font-weight: 400;
    font-size: 14px;
    color: var(--dk-text-primary, #3f4254);
  }

  &:after {
    content: '';
    position: absolute;
    left: 26px;
    bottom: 4px;
    width: 12px;
    height: 12px;
    border: 1px solid var(--dk-bg, white);
    border-radius: 100%;
    background-image: url('/icons/like_circle_on.svg');
  }
`;

export const FoldButton = styled(Stack)`
  width: auto;
  padding: 0;
  color: var(--dk-accent, #06c);
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background-color: transparent;
    text-decoration: underline;
  }
`;
